package pnemonic.balloon_pop.drawable

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val Level: ImageVector
    get() {
        if (_Level != null) {
            return _Level!!
        }
        _Level = ImageVector.Builder(
            name = "Level",
            defaultWidth = 48.dp,
            defaultHeight = 31.dp,
            viewportWidth = 48f,
            viewportHeight = 31f
        ).apply {
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(14.232f, 12.52f)
                lineToRelative(1.672f, -4.42f)
                lineToRelative(-15.759f, -5.961f)
                curveToRelative(0f, 0f, -1.145f, 4.619f, 2.996f, 6.186f)
                curveToRelative(4.142f, 1.567f, 11.091f, 4.195f, 11.091f, 4.195f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(15.581f, 18.606f)
                lineToRelative(1.672f, -4.419f)
                lineToRelative(-15.759f, -5.961f)
                curveToRelative(0f, 0f, -1.146f, 4.619f, 2.996f, 6.185f)
                curveToRelative(4.142f, 1.567f, 11.091f, 4.195f, 11.091f, 4.195f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(2.843f, 14.311f)
                curveToRelative(0f, 0f, -1.146f, 4.619f, 2.996f, 6.185f)
                curveToRelative(4.142f, 1.567f, 11.091f, 4.195f, 11.091f, 4.195f)
                lineToRelative(1.672f, -4.42f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFDA33))) {
                moveToRelative(14.232f, 10.381f)
                lineToRelative(1.672f, -4.42f)
                lineToRelative(-15.759f, -5.961f)
                curveToRelative(0f, 0f, -1.145f, 4.619f, 2.996f, 6.185f)
                curveToRelative(4.142f, 1.567f, 11.091f, 4.195f, 11.091f, 4.195f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFDA33))) {
                moveToRelative(15.581f, 16.467f)
                lineToRelative(1.672f, -4.42f)
                lineToRelative(-15.759f, -5.961f)
                curveToRelative(0f, 0f, -1.146f, 4.619f, 2.996f, 6.186f)
                curveToRelative(4.142f, 1.566f, 11.091f, 4.195f, 11.091f, 4.195f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFDA33))) {
                moveToRelative(2.843f, 12.173f)
                curveToRelative(0f, 0f, -1.146f, 4.618f, 2.996f, 6.185f)
                curveToRelative(4.142f, 1.567f, 11.091f, 4.195f, 11.091f, 4.195f)
                lineToRelative(1.672f, -4.42f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(10.683f, 18.499f)
                curveToRelative(0.158f, 0.69f, 0.378f, 1.334f, 0.648f, 1.936f)
                curveToRelative(2.98f, 1.127f, 5.599f, 2.118f, 5.599f, 2.118f)
                lineTo(18.601f, 18.133f)
                lineTo(10.139f, 14.932f)
                curveToRelative(0.09f, 1.14f, 0.262f, 2.336f, 0.544f, 3.567f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(10.104f, 14.395f)
                curveToRelative(2.929f, 1.108f, 5.477f, 2.072f, 5.477f, 2.072f)
                lineToRelative(1.672f, -4.42f)
                lineToRelative(-6.964f, -2.634f)
                curveToRelative(-0.191f, 1.449f, -0.292f, 3.137f, -0.185f, 4.982f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(15.904f, 5.961f)
                lineToRelative(-4.387f, -1.66f)
                curveToRelative(-0.153f, 0.392f, -0.778f, 2.093f, -1.158f, 4.614f)
                curveToRelative(2.196f, 0.831f, 3.873f, 1.466f, 3.873f, 1.466f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(33.593f, 12.52f)
                lineToRelative(-1.672f, -4.42f)
                lineToRelative(15.759f, -5.961f)
                curveToRelative(0f, 0f, 1.145f, 4.619f, -2.996f, 6.186f)
                curveToRelative(-4.142f, 1.567f, -11.091f, 4.195f, -11.091f, 4.195f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(32.245f, 18.606f)
                lineToRelative(-1.672f, -4.419f)
                lineToRelative(15.759f, -5.961f)
                curveToRelative(0f, 0f, 1.146f, 4.619f, -2.996f, 6.185f)
                curveToRelative(-4.142f, 1.567f, -11.091f, 4.195f, -11.091f, 4.195f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(44.982f, 14.311f)
                curveToRelative(0f, 0f, 1.146f, 4.619f, -2.996f, 6.185f)
                curveToRelative(-4.142f, 1.567f, -11.091f, 4.195f, -11.091f, 4.195f)
                lineToRelative(-1.672f, -4.42f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFDA33))) {
                moveToRelative(33.593f, 10.381f)
                lineToRelative(-1.672f, -4.42f)
                lineToRelative(15.759f, -5.961f)
                curveToRelative(0f, 0f, 1.145f, 4.619f, -2.996f, 6.185f)
                curveToRelative(-4.142f, 1.567f, -11.091f, 4.195f, -11.091f, 4.195f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFDA33))) {
                moveToRelative(32.245f, 16.467f)
                lineToRelative(-1.672f, -4.42f)
                lineToRelative(15.759f, -5.961f)
                curveToRelative(0f, 0f, 1.146f, 4.619f, -2.996f, 6.186f)
                curveToRelative(-4.142f, 1.566f, -11.091f, 4.195f, -11.091f, 4.195f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFDA33))) {
                moveToRelative(44.982f, 12.173f)
                curveToRelative(0f, 0f, 1.146f, 4.618f, -2.996f, 6.185f)
                curveToRelative(-4.142f, 1.567f, -11.091f, 4.195f, -11.091f, 4.195f)
                lineToRelative(-1.672f, -4.42f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(37.142f, 18.499f)
                curveToRelative(-0.158f, 0.69f, -0.378f, 1.334f, -0.648f, 1.936f)
                curveToRelative(-2.98f, 1.127f, -5.599f, 2.118f, -5.599f, 2.118f)
                lineToRelative(-1.672f, -4.42f)
                lineToRelative(8.462f, -3.201f)
                curveToRelative(-0.09f, 1.14f, -0.262f, 2.336f, -0.544f, 3.567f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(37.722f, 14.395f)
                curveToRelative(-2.929f, 1.108f, -5.477f, 2.072f, -5.477f, 2.072f)
                lineToRelative(-1.672f, -4.42f)
                lineToRelative(6.964f, -2.634f)
                curveToRelative(0.191f, 1.449f, 0.292f, 3.137f, 0.185f, 4.982f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(31.921f, 5.961f)
                lineToRelative(4.387f, -1.66f)
                curveToRelative(0.153f, 0.392f, 0.778f, 2.093f, 1.158f, 4.614f)
                curveToRelative(-2.196f, 0.831f, -3.873f, 1.466f, -3.873f, 1.466f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(34.744f, 6.549f)
                lineToRelative(-5.218f, 0.559f)
                lineToRelative(-5.613f, -3.757f)
                lineToRelative(0f, -0f)
                lineToRelative(0f, 0f)
                lineToRelative(-0f, 0f)
                lineToRelative(0f, 0f)
                lineToRelative(-5.613f, 3.757f)
                lineToRelative(-5.217f, -0.559f)
                curveToRelative(0f, 0f, -2.671f, 6.398f, -0.87f, 14.286f)
                curveToRelative(1.8f, 7.885f, 11.691f, 9.812f, 11.701f, 9.814f)
                lineToRelative(0f, 0f)
                lineToRelative(0f, 0f)
                lineToRelative(0f, 0f)
                lineToRelative(0f, 0f)
                curveToRelative(0.01f, -0.002f, 9.9f, -1.929f, 11.701f, -9.814f)
                curveToRelative(1.801f, -7.888f, -0.87f, -14.286f, -0.87f, -14.286f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFDA33))) {
                moveToRelative(34.744f, 4.888f)
                lineToRelative(-5.218f, 0.559f)
                lineToRelative(-5.613f, -3.757f)
                lineToRelative(0f, 0f)
                lineToRelative(0f, 0f)
                lineToRelative(-0f, 0f)
                lineToRelative(0f, 0f)
                lineToRelative(-5.613f, 3.757f)
                lineToRelative(-5.217f, -0.559f)
                curveToRelative(0f, 0f, -2.671f, 6.398f, -0.87f, 14.286f)
                curveToRelative(1.8f, 7.885f, 11.691f, 9.812f, 11.701f, 9.814f)
                lineToRelative(0f, 0f)
                lineToRelative(0f, 0f)
                lineToRelative(0f, 0f)
                lineToRelative(0f, 0f)
                curveToRelative(0.01f, -0.002f, 9.9f, -1.929f, 11.701f, -9.814f)
                curveToRelative(1.801f, -7.889f, -0.87f, -14.286f, -0.87f, -14.286f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFAA17))) {
                moveToRelative(23.913f, 26.442f)
                curveToRelative(-1.794f, -0.474f, -8.071f, -2.497f, -9.287f, -7.819f)
                curveToRelative(-1.069f, -4.684f, -0.373f, -8.829f, 0.204f, -11.057f)
                lineToRelative(4.099f, 0.439f)
                lineToRelative(4.983f, -3.336f)
                lineToRelative(4.983f, 3.336f)
                lineToRelative(4.1f, -0.439f)
                curveToRelative(0.576f, 2.225f, 1.273f, 6.372f, 0.203f, 11.057f)
                curveToRelative(-1.215f, 5.322f, -7.492f, 7.345f, -9.286f, 7.819f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFF8800))) {
                moveToRelative(18.601f, 8.981f)
                lineToRelative(5.211f, -3.336f)
                lineToRelative(5.211f, 3.336f)
                lineToRelative(4.202f, -0.43f)
                curveToRelative(-0.076f, -0.359f, -0.155f, -0.689f, -0.231f, -0.985f)
                lineToRelative(-4.1f, 0.439f)
                lineToRelative(-4.983f, -3.336f)
                lineToRelative(-4.983f, 3.336f)
                lineToRelative(-4.099f, -0.439f)
                curveToRelative(-0.078f, 0.301f, -0.157f, 0.638f, -0.235f, 1.004f)
                close()
            }
        }.build()

        return _Level!!
    }

@Suppress("ObjectPropertyName")
private var _Level: ImageVector? = null
